// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"zC","reco":"AC","products":"BC"};